







































import { Component, Prop, Vue, Watch } from "vue-property-decorator";


import { PinBoard } from "../../models/pinboard.model";

import SearchInput from "@/components/SearchInput.vue";
import BackButton from "@/components/BackButton.vue";
import UserListCard from "@/components/Admin/UserListCard.vue";
import UserModal from "@/components/Admin/UserModal.vue";

import { userService } from "@/services/user.service";
import { pinboardService } from "@/services/pinboard.service";
import { User } from '@/models/user.model';

@Component({
    components : {
        SearchInput,
        BackButton,
        UserListCard,
        UserModal
    }
})
export default class AdminUser extends Vue{
    filterWeek:boolean = true;
    filterMonth:boolean = false;
    isModalVisible:boolean = false;
    users: User[] = [];
    userId:number = 0;
    pinboards:PinBoard[] = [];
    selectedPinboard:number[] = [];
    searchQuery:string = "";

    async created(){
        this.load();
        // this.pinboards = await pinboardService.getAll();
    }

    async load(){
        this.users = await userService.getAll(this.$store.getters["app/companyId"]);
        console.log(this.users);
    }

    edit(id:number){
        this.userId = id;
        this.isModalVisible = true;
    }

    async remove(id:number){
        this.userId = id;
        var r = confirm("Sure you want to delete?");
        if (r == true) {
            await userService.delete(id).then(() => {
                this.load();
                this.$notify({
                    group: 'message',
                    title: 'Succe!',
                    text: 'Användare borttaget',
                    duration: 5000,
                    type: 'success',
                });
            });
        }
    }
    
    get filteredList(){
        let filterList = this.users;
        if(this.searchQuery != "" && this.searchQuery.length > 1){
            filterList = filterList.filter(c => c.firstName!.toLowerCase().startsWith(this.searchQuery.toLowerCase()));
            if(filterList.length == 0)
                filterList = this.users.filter(cu => cu.lastName!.toLowerCase().startsWith(this.searchQuery.toLowerCase()));
        }

        return filterList;
    }

    
    openModal(){
        this.isModalVisible = true;
        this.userId = 0;
    }

    modalEvent(obj:any,id:any){
        this.isModalVisible = obj == "close" || obj == "saved" ? false : true;
        this.userId = id != undefined ? id : this.userId;
        if(obj="saved")
            this.load();
    }
}
